function Converter() {
  return (
    <>
      <p>Converter</p>
    </>
  );
}

export default Converter;
